import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl text-white mb-4">
              <Link to="/" className="cursor-pointer hover:text-primary-400 transition-colors">yy漫画网</Link>
            </h4>
            <p className="text-sm text-secondary-300 leading-relaxed">
              yy漫画网作为漫画韩漫网址，提供韩漫免费漫画和在线阅读下拉式韩国漫画，资源丰富且访问快捷，让您随时享受阅读时光。
            </p>
          </div>

          <div>
            <h4 className="font-medium text-white mb-4">快捷导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-white mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-secondary-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-medium text-white mb-4">联系方式</h4>
            <ul className="space-y-2 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400" />
                <span>contact@yymanhua.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-line text-primary-400" />
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-400">
            &copy; {new Date().getFullYear()} yy漫画网 版权所有 | 韩漫免费漫画在线阅读平台
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer" rel="nofollow">使用条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}